var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('ScaleFilter',{on:{"applyScale":_vm.updateScale}}),_c('GuitarNeck',{attrs:{"stringsNumber":6,"freatsNumber":18,"scale":_vm.currentScale}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }